"use client";

import { Core } from "@faire/slate/foundation/color";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

// TODO(alipianu): sync from Figma
/**
 * @trackcomponent
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7%3A318))
 * @lastsynced 2025-07-07T19:22:53.621Z
 * @optimized using svgo:^3.0.2
 */
export const ArrowDown = createSVGIcon(
  <path
    d="M12 .857v22.286M18 17.143l-6 6-6-6"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ArrowDown",
  {
    viewBox: "0 0 24 24",
    color: Core.icon.primary,
    fill: "none",
  }
);
